import * as React from 'react';
import strings from './strings';
import './style/index.scss';
const dateFormatStr = 'MMMM DD, YYYY';
class EmployeeDetailsCard extends React.PureComponent {
    render() {
        const { dateOfHire, employeeId, workLocation, managerName, email, department, dateFormatter } = this.props;
        if (dateOfHire == null &&
            employeeId == null &&
            workLocation == null &&
            managerName == null &&
            email == null &&
            department == null) {
            return null;
        }
        return (React.createElement("ul", { className: "ee-details-card" },
            dateOfHire && this._renderListItem(strings.hireDate, dateFormatter ?
                dateFormatter(dateOfHire, dateFormatStr) :
                dateOfHire, 'icon-calendar'),
            employeeId && this._renderListItem(strings.employeeId, employeeId, 'icon-v-card'),
            workLocation && this._renderListItem(strings.location, workLocation, 'icon-location'),
            managerName && this._renderListItem(strings.manager, managerName, 'icon-user'),
            email && this._renderListItem(strings.email, React.createElement("a", { className: "underline sensitive-info", href: `mailto:${email}` }, email), 'icon-paper-plane'),
            department && this._renderListItem(strings.department, department, 'icon-sitemap')));
    }
    _renderListItem(title, content, icon) {
        return (React.createElement("li", { className: "ee-details-card__list-item", key: title },
            React.createElement("div", { className: "ee-details-card__item" },
                React.createElement("i", { className: `ee-details-card__item-icon ${icon}` }),
                React.createElement("div", { className: "ee-details-card__item-content" },
                    React.createElement("h5", { className: "ee-details-card__item-header" }, title),
                    React.createElement("div", { className: 'ee-details-card__item-value' },
                        React.createElement("span", { className: (title === 'Reports To' ? 'sensitive-info' : '') }, content))))));
    }
}
export { EmployeeDetailsCard };
export default EmployeeDetailsCard;
